import * as SDK from "../index";

/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/**
 * Mv Address Locator demo - Just for fast viewing purposes
 * For demo purposes only
 * @type {MvAddressLocatorDemo instance}
 */
(
    function () {
        const button = document.getElementById("select_button");
        const result_count = document.getElementById("address_count");

        const MvAddressLocatorDemo = window.MVAddressSelectorSDK || SDK;

        button.addEventListener("click", () => {
            result_count.innerHTML = 0;
            const demo = MvAddressLocatorDemo.init({
                containerId: "mv-address-locator",
                apiBasePath: __SDK_API_BASE_PATH__,
                useModal: true,
                pricePerAddress: 1.3,
                startRadius: 2000,
                maxRadius: 2500,
                zipCodeAreaMinCount: 200,
                addressLimit: 1000,
                // selectedAddress: {
                //     // FLC to backend with testdata
                //     streetname: "Bachstraße",
                //     countryCode: "de", // de
                //     postcode: "51598",
                //     huisnr: "7",
                // },
                selectedAddress: {
                    streetname: "Heerstraße",
                    countryCode: "de",
                    postcode: "52538",
                    huisnr: "84",
                },
                // zipCodeAreaMinCount: 200,
                // selectedAddress: {
                //     countryCode: "nl",
                //     postcode: "6365CT",
                //     huisnr: "5",
                //     huisnr_bag_letter: "",
                //     huisnr_bag_toevoeging: "",
                // },
                //selectedAddress: {
                //    streetname: "Laarmannstraße",
                //    postcode: "44879",
                //    huisnr: 12,
                //    countryCode: "de",
                //},
                // addressLimit: 2000,
                language: "de",
                onComplete: function (event) {
                    // total function for DE (see nl-test for NL totals)
                    const addressCount = event.currentSelection.reduce(
                        (partialSum, a) =>
                            partialSum +
                            a.selectedAddresses.reduce(
                                (partialSum, adress) =>
                                    partialSum + adress.total,
                                0,
                            ),
                        0,
                    );
                    demo.setOptions({ isModalOpen: false });
                    console.log(event.currentSelection);
                    result_count.innerHTML = addressCount;
                },
                onCancel: function (event) {
                    console.log(event);
                },
                onError: function (event) {
                    console.log(event);
                },
                onModalRequestClose: function () {
                    console.log("request to close!");
                    // Update options with the state of the modal
                    demo.setOptions({ isModalOpen: false });
                },
            });
        });
    }
)();
